import React from 'react';
import s from './index.module.css';

export function SearchBar({ onKeyChange = () => null }) {

  const handleChange = (e) => {
    onKeyChange(e.target.value);
  }

  return (
    <div className={s.container}>
      <div className={s.searchBar}>
        <span className={s.searchIcon}>🔍</span>
        <input 
          type="text" 
          placeholder="Search menu" 
          className={s.searchInput} 
          onChange={handleChange}
        />
      </div>
      {/* <button className={s.searchButton}>
        <span className={s.searchIcon}>🔍</span>
      </button> */}
    </div>
  );
} 